// extracted by mini-css-extract-plugin
module.exports = {"authOptionsWrapper":"LoggedInHeader_authOptionsWrapper__afQsA","createQuestBtn":"LoggedInHeader_createQuestBtn__BSMAd","dropdown":"LoggedInHeader_dropdown__yE708"};